/**
 * Created by razial on 18.09.2026.
 */

cleverapps.InitByFeature["growthfund"] = function () {
    cleverapps.growthFund = new GrowthFund();
};

DataLoader.TYPES.GROWTHFUND = "_growthfund";

cleverapps.EVENTS.EARN.GROWTH_FUND = "fund";
cleverapps.EVENTS.FUND_BUY = "bought_fund";
cleverapps.EVENTS.FUND_DAU = "growth_fund_dau";
cleverapps.EVENTS.FUND_GOLD = "growth_fund_gold";

SyncAdapters.growthfund = {
    getInfo: () => cleverapps.growthFund.getInfo(),

    updateInfo: (serverData) => cleverapps.growthFund.updateInfo(serverData)
};

Reward.register("growthFund", {
    getIcon: function () {
        return bundles.reward_icons.frames.growth_fund_png;
    },

    getAmount: function (value) {
        return value.amount || 1;
    },

    getPrice: function (value) {
        return Product.CalcHardPrice(GrowthFund.PRODUCT) * this.getAmount(value);
    },

    getText: function () {
        return Messages.get("Shop.growthFund.title");
    },

    receive: function () {
        if (cleverapps.growthFund && !cleverapps.growthFund.isBought()) {
            cleverapps.growthFund.processBought(true);
        }
    }
});

Placements.ENTRIES["growthFund"] = {
    throttled: true,

    type: Placements.FREE_FOCUS_MAIN,
    priority: -2,
    filter: function () {
        return cleverapps.growthFund && cleverapps.growthFund.wantsAttention && cleverapps.growthFund.isActive();
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "GrowthFundNudge",
            action: function (f) {
                new GrowthFundWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};
